import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import TextArea from "../../components/atoms/input/textarea";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import ReportModal from "../../components/templates/modals/reportModal";
import CommunityApi from "../../api/community.api";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";
import moment from "moment";
import {
  formatNumberKM,
  formatNumberWithCommas,
} from "../../util/formatNumber";
import { fileUrl } from "../../api/api";
import { macOSCheck } from "../../util/macOSCheck";
import Loading from "../../components/templates/loading";

const CommunityDetail = () => {
  const { id } = useParams();

  const location = useLocation();
  const requestedCategoryValue = Number(location.state?.categoryValue);
  const categoryValue =
    Number.isInteger(requestedCategoryValue) && requestedCategoryValue > 0
      ? requestedCategoryValue
      : -1;

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  const [comments, setComments] = useState("");
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isReportModal, setIsReportModal] = useState(false);
  const [isCommentDelModal, setIsCommentDelModal] = useState(false);

  const [communityInfo, setCommunityInfo] = useState(null);
  const [commentList, setCommentList] = useState([]);
  const [commentReportId, setCommentReportId] = useState(0);
  const [nextCommunityInfo, setNextCommunityInfo] = useState();
  const [preCommunityInfo, setPreCommunityInfo] = useState();
  const [commentDelId, setCommentDelId] = useState(0);
  const [commentEditId, setCommentEditId] = useState(0);
  const [editComments, setEditComments] = useState("");
  const [isCommentProcessing, setIsCommentProcessing] = useState(false);
  const [isPostProcessing, setIsPostProcessing] = useState(false);
  const [isReportProcessing, setIsReportProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const communityId = Number(id);
    if (!Number.isInteger(communityId) || communityId <= 0) {
      toast("잘못된 커뮤니티 주소입니다.");
      navigate(route.community_list, { replace: true });
      return;
    }

    setCommunityInfo(null);
    setCommentList([]);
    setPreCommunityInfo();
    setNextCommunityInfo();
    getInfo();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (communityInfo?.id) {
      getNextPreCommunityInfo();
    }
  }, [communityInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const getNextPreCommunityInfo = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        cursor: communityInfo.id,
        sort: "id",
        orderBy: "DESC",
        activation: "Active",
      };

      if (categoryValue > 0) {
        data.communityCategoryId = categoryValue;
      }

      const response = (await CommunityApi.getList(data)).data.data.content;

      if (response && response.length > 0) {
        setPreCommunityInfo(response[0]);
      } else {
        setPreCommunityInfo();
      }

      const data02 = {
        page: 1,
        size: 1,
        cursor: communityInfo.id,
        sort: "id",
        orderBy: "ASC",
        activation: "Active",
      };

      if (categoryValue > 0) {
        data02.communityCategoryId = categoryValue;
      }

      const response02 = (await CommunityApi.getList(data02)).data.data.content;

      if (response02 && response02.length > 0) {
        setNextCommunityInfo(response02[0]);
      } else {
        setNextCommunityInfo();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const getInfo = async () => {
    setIsLoading(true);
    try {
      const response = (await CommunityApi.getDetail(id)).data.data.content;

      setCommunityInfo(response);

      await getCommmentList(response.id);
    } catch (error) {
      errorHandler(error);
      navigate(route.community_list, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  const getCommmentList = async (id) => {
    try {
      const data = {
        page: 1,
        size: 0,
        communityPostId: id ? id : communityInfo.id,
      };

      const response = (await CommunityApi.commentList(data)).data.data.content;

      setCommentList(response ?? []);
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleCopyClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);

      toast("주소가 복사되었습니다.");
    } catch (error) {
      toast("주소를 복사하지 못했습니다.");
    }
  };

  const addCommmentList = async () => {
    const content = comments.trim();
    if (isCommentProcessing || !content || !communityInfo?.id) return;
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("댓글을 작성하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setIsCommentProcessing(true);
    try {
      const data = {
        communityPostId: communityInfo.id,
        content,
      };
      await CommunityApi.registerComment(data);

      setComments("");
      await getCommmentList();

      toast("댓글이 등록되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  const deleteCommunityFunc = async () => {
    if (isPostProcessing || !communityInfo?.id) return;
    setIsPostProcessing(true);
    try {
      const data = {
        ids: [communityInfo.id],
        allFlag: false,
      };
      await CommunityApi.delCommunity(data);

      toast("커뮤니티가 삭제되었습니다.");
      navigate(route.community_list, { replace: true });
    } catch (error) {
      errorHandler(error);
      setIsPostProcessing(false);
    }
  };

  const openReportModal = (postCommentId = 0) => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("신고하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setCommentReportId(postCommentId);
    setIsReportModal(true);
  };

  const reportFunc = async (value) => {
    if (isReportProcessing || !communityInfo?.id) return;
    setIsReportProcessing(true);
    try {
      const data =
        commentReportId === 0
          ? {
              communityPostId: communityInfo.id,
              reason: value,
              postFlag: true,
            }
          : {
              postCommentId: commentReportId,
              reason: value,
              postFlag: false,
            };

      await CommunityApi.report(data);

      setCommentReportId(0);
      toast("신고되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsReportModal(false);
      setIsReportProcessing(false);
    }
  };

  const deleteCommentFunc = async () => {
    if (isCommentProcessing || !commentDelId) return;
    setIsCommentProcessing(true);
    try {
      const data = {
        ids: [commentDelId],
        allFlag: false,
      };
      await CommunityApi.delComment(data);

      setCommentDelId(0);
      await getCommmentList();

      toast("댓글이 삭제되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  const editCommmentList = async () => {
    const content = editComments.trim();
    if (isCommentProcessing || !commentEditId || !content) return;
    setIsCommentProcessing(true);
    try {
      const data = {
        content,
      };

      await CommunityApi.editComment(commentEditId, data);

      setEditComments("");
      setCommentEditId(0);
      await getCommmentList();

      toast("댓글이 수정되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <CommunityDetailSection>
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isMobile
              ? "40px 20px 80px 20px"
              : isTablet
                ? "40px 60px 80px 60px"
                : "80px 0px 161px 0px",
            width: "100%",
          }}
        >
          <div
            onClick={() => {
              navigate(-1);
            }}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: 20,
            }}
          >
            <img
              src="/assets/icons/left_text.svg"
              alt="left_text"
              style={{
                width: isMobile ? 6 : 8,
                height: isMobile ? 12 : 14,
              }}
            />

            <LSRgH1HeadLine
              style={{
                color: "#101113",
                marginTop: 2,
                marginLeft: isMobile ? 6 : 10,
                fontSize: isMobile ? 10 : 16,
                lineHeight: isMobile ? "12px" : "22.4px",
              }}
            >
              뒤로가기
            </LSRgH1HeadLine>
          </div>

          <WhiteBoxContain $isMobile={isMobile}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 24,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    border: "1px solid #5050FF",
                    borderRadius: 30,
                    padding: "4px 14px",
                    alignSelf: "flex-start",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <LSBdBody01
                    style={{
                      color: "#5050FF",
                      marginTop: macOSCheck() ? 0 : 2,
                    }}
                  >
                    {communityInfo?.communityCategory?.title}
                  </LSBdBody01>
                </div>
                <LSBdDisplay02
                  style={{
                    color: "#000000",
                    fontSize: isMobile ? 18 : 24,
                    lineHeight: isMobile ? "25.2px" : "33.6px",
                  }}
                >
                  {communityInfo?.title}
                </LSBdDisplay02>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: isMobile ? "12px 0px" : "16px 0px",
                borderTop: "1px solid #DBDDE0",
                borderBottom: "1px solid #DBDDE0",
              }}
            >
              <img
                style={{
                  height: 40,
                  width: 40,
                  marginRight: 16,
                }}
                src={
                  communityInfo?.member?.profileServerFileName
                    ? `${fileUrl}/${communityInfo.member.profileServerFileName}`
                    : "/assets/icons/profile.png"
                }
                alt="profile"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <LSBdBody01
                  style={{
                    color: "#000000",
                    fontSize: isMobile ? 12 : 14,
                    lineHeight: isMobile ? "14.4px" : "19.6px",
                    marginBottom: isMobile ? 4 : 0,
                  }}
                >
                  {communityInfo?.member?.nickname}
                </LSBdBody01>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <LSRgCaption02
                    style={{
                      color: "#000000",
                      marginRight: 24,
                      fontSize: isMobile ? 10 : 12,
                      lineHeight: isMobile ? "12px" : "14.4px",
                    }}
                  >
                    {moment(communityInfo?.createdAt).format("YYYY.MM.DD")}
                  </LSRgCaption02>
                  <img
                    style={{
                      height: isMobile ? 14 : 18,
                      width: isMobile ? 14 : 18,
                      marginRight: 6,
                    }}
                    src="/assets/icons/carbon_view.png"
                    alt="carbon_view"
                  />
                  <LSRgCaption02
                    style={{
                      color: "#000000",
                      fontSize: isMobile ? 10 : 12,
                      lineHeight: isMobile ? "12px" : "14.4px",
                    }}
                  >
                    {formatNumberKM(
                      communityInfo?.viewCount ? communityInfo?.viewCount : 0,
                    )}
                  </LSRgCaption02>
                </div>
              </div>
            </div>

            <LSRgH1HeadLine
              className="ql-editor"
              style={{
                color: "#000000",
                fontSize: isMobile ? 14 : 16,
                lineHeight: isMobile ? "19.6px" : "22.4px",
                marginTop: isMobile ? 20 : 30,
              }}
              dangerouslySetInnerHTML={{
                __html: communityInfo?.content,
              }}
            />

            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                alignItems: isMobile ? "flex-start" : "center",
                marginTop: isMobile ? 20 : 30,
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: isMobile ? "flex-end" : "flex-start",
                  marginBottom: isMobile ? 20 : 0,
                  width: "100%",
                }}
              >
                <div
                  onClick={() => {
                    handleCopyClipBoard();
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    cursor: "pointer",
                    marginRight: isMobile ? 20 : 30,
                  }}
                >
                  <img
                    style={{
                      height: 16,
                      width: 16,
                    }}
                    src="/assets/icons/share.png"
                    alt="share"
                  />

                  <LSRgBody01
                    style={{
                      color: "#A4A8B1",
                      marginLeft: 10,
                      fontSize: isMobile ? 12 : 14,
                      lineHeight: isMobile ? "14.4px" : "19.6px",
                    }}
                  >
                    공유
                  </LSRgBody01>
                </div>
                {communityInfo?.member?.id ===
                Number(sessionStorage.getItem("id")) ? null : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      openReportModal();
                    }}
                  >
                    <img
                      style={{
                        height: 16,
                        width: 16,
                      }}
                      src="/assets/icons/report.png"
                      alt="report"
                    />
                    <LSRgBody01
                      style={{
                        color: "#A4A8B1",
                        marginLeft: 10,
                        fontSize: isMobile ? 12 : 14,
                        lineHeight: isMobile ? "14.4px" : "19.6px",
                      }}
                    >
                      신고
                    </LSRgBody01>
                  </div>
                )}
              </div>
              {communityInfo?.member?.id ===
              Number(sessionStorage.getItem("id")) ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  <MainBtn
                    onClick={() => {
                      navigate(`${route.community_edit}/${communityInfo?.id}`);
                    }}
                    style={{
                      width: isMobile ? "100%" : 72,
                      height: 36,
                      background: "#F6F7F8",
                      marginRight: 10,
                      borderRadius: 8,
                    }}
                  >
                    <LSRgBody01
                      style={{
                        color: "#A4A8B1",
                        textAlign: "center",
                      }}
                    >
                      수정
                    </LSRgBody01>
                  </MainBtn>
                  <MainBtn
                    onClick={() => {
                      setIsDeleteModal(true);
                    }}
                    style={{
                      width: isMobile ? "100%" : 72,
                      height: 36,
                      borderRadius: 8,
                      background: "#F24147",
                    }}
                  >
                    <LSRgBody01
                      style={{
                        color: "#FFFFFF",
                        textAlign: "center",
                      }}
                    >
                      삭제
                    </LSRgBody01>
                  </MainBtn>
                </div>
              ) : null}
            </div>
          </WhiteBoxContain>

          <WhiteBoxContain
            $isMobile={isMobile}
            style={{
              marginTop: isMobile ? 20 : 40,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                paddingBottom: isMobile ? 12 : 16,
                borderBottom: "1px solid #DBDDE0",
              }}
            >
              <LSBdH2HeadLine
                style={{
                  color: "#101113",
                  fontSize: isMobile ? 15 : 18,
                  lineHeight: isMobile ? "21px" : "25.2px",
                  marginRight: isMobile ? 8 : 6,
                }}
              >
                댓글
              </LSBdH2HeadLine>
              <LSBdH2HeadLine
                style={{
                  color: "#5050FF",
                  fontSize: isMobile ? 15 : 18,
                  lineHeight: isMobile ? "21px" : "25.2px",
                }}
              >
                {formatNumberWithCommas(commentList.length)}
              </LSBdH2HeadLine>
            </div>

            {commentList.map((item) => {
              return (
                <div
                  key={item.id}
                  style={{
                    marginTop: isMobile ? 20 : 30,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <img
                    style={{
                      height: isMobile ? 30 : 50,
                      width: isMobile ? 30 : 50,
                      marginRight: isMobile ? 20 : 30,
                      borderRadius: 999,
                    }}
                    src={
                      item.member?.profileServerFileName
                        ? `${fileUrl}/${item.member.profileServerFileName}`
                        : "/assets/icons/profile.png"
                    }
                    alt="profile"
                  />
                  {commentEditId === item.id ? (
                    <div
                      style={{
                        background: "#F6F7F880",
                        width: "100%",
                        borderRadius: 15,
                        padding: isMobile ? "10px" : "20px 30px 56px 30px",
                        position: "relative",
                      }}
                    >
                      <LSBdH2HeadLine
                        style={{
                          color: "#000000",
                          marginBottom: isMobile ? 7 : 15,
                          fontSize: isMobile ? 12 : 18,
                          lineHeight: isMobile ? "16.8px" : "25.2px",
                        }}
                      >
                        {sessionStorage.getItem("nickname")}
                      </LSBdH2HeadLine>

                      <TextArea
                        placeholder="댓글을 입력해 보세요."
                        value={editComments}
                        onChange={(e) => {
                          setEditComments(e.target.value);
                        }}
                        style={{
                          background: "#F6F7F880",
                          border: "none",
                          height: 110,
                        }}
                      />

                      <MainBtn
                        disabled={isCommentProcessing || !editComments.trim()}
                        onClick={() => {
                          editCommmentList();
                        }}
                        style={{
                          width: 60,
                          height: isMobile ? 28 : 32,
                          borderRadius: 8,
                          position: "absolute",
                          bottom: 20,
                          right: 20,
                        }}
                      >
                        <LSBdBody02
                          style={{
                            color: "#FFFFFF",
                            textAlign: "center",
                            fontSize: isMobile ? 12 : 15,
                            lineHeight: isMobile ? "16.8px" : "21px",
                          }}
                        >
                          수정
                        </LSBdBody02>
                      </MainBtn>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "84%",
                      }}
                    >
                      <LSBdH2HeadLine
                        style={{
                          color: "#000000",
                          margin: isMobile ? "0px" : "12px 0px",
                          fontSize: isMobile ? 12 : 18,
                          lineHeight: isMobile ? "14.4px" : "25.2px",
                        }}
                      >
                        {item.member?.nickname ?? "회원"}
                      </LSBdH2HeadLine>

                      <LSRgH1HeadLine
                        style={{
                          color: "#000000",
                          margin: "8px 0px",
                          fontSize: isMobile ? 12 : 16,
                          lineHeight: isMobile ? "14.4px" : "22.4px",
                          wordWrap: "break-word" /* 단어를 자를 수 있게 설정 */,
                          overflowWrap:
                            "break-word" /* 단어가 넘칠 경우 줄바꿈 */,
                          whiteSpace:
                            "pre-wrap" /* 공백도 유지하고 자동 줄바꿈 허용 */,
                        }}
                      >
                        {item.content}
                      </LSRgH1HeadLine>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <LSRgBody01
                          style={{
                            color: "#A4A8B1",
                            marginRight: 20,
                            fontSize: isMobile ? 10 : 14,
                            lineHeight: isMobile ? "12px" : "19.6px",
                            width: isMobile ? "100%" : "auto",
                            marginTop: macOSCheck() ? 0 : 4,
                          }}
                        >
                          {moment(item.createdAt).format("YYYY.MM.DD HH:mm")}
                        </LSRgBody01>

                        {item?.member?.id ===
                        Number(sessionStorage.getItem("id")) ? (
                          <>
                            <LSRgBody01
                              onClick={() => {
                                setCommentEditId(item.id);
                                setEditComments(item.content);
                              }}
                              style={{
                                color: "#A4A8B1",
                                cursor: "pointer",
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              수정
                            </LSRgBody01>
                            <LSRgBody01
                              onClick={() => {
                                setIsCommentDelModal(true);
                                setCommentDelId(item.id);
                              }}
                              style={{
                                color: "#A4A8B1",
                                marginLeft: 12,
                                cursor: "pointer",
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              삭제
                            </LSRgBody01>
                          </>
                        ) : (
                          <>
                            <img
                              onClick={() => {
                                openReportModal(item.id);
                              }}
                              style={{
                                height: isMobile ? 12 : 16,
                                width: isMobile ? 12 : 16,
                                cursor: "pointer",
                              }}
                              src="/assets/icons/report.png"
                              alt="report"
                            />
                            <LSRgBody01
                              onClick={() => {
                                openReportModal(item.id);
                              }}
                              style={{
                                color: "#A4A8B1",
                                marginLeft: isMobile ? 5 : 10,
                                cursor: "pointer",
                                marginTop: macOSCheck() ? 0 : 4,
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              신고
                            </LSRgBody01>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            <div
              style={{
                marginTop: isMobile ? 20 : 30,
                background: "#F6F7F880",
                width: "100%",
                borderRadius: 15,
                padding: isMobile ? "10px" : "20px 30px 56px 30px",
                position: "relative",
              }}
            >
              <LSBdH2HeadLine
                style={{
                  color: "#000000",
                  marginBottom: isMobile ? 7 : 15,
                  fontSize: isMobile ? 12 : 18,
                  lineHeight: isMobile ? "16.8px" : "25.2px",
                }}
              >
                {sessionStorage.getItem("nickname")}
              </LSBdH2HeadLine>

              <TextArea
                placeholder="댓글을 입력해 보세요."
                value={comments}
                onChange={(e) => {
                  setComments(e.target.value);
                }}
                style={{
                  background: "#F6F7F880",
                  border: "none",
                  height: 110,
                }}
              />

              <MainBtn
                disabled={isCommentProcessing || !comments.trim()}
                onClick={() => {
                  addCommmentList();
                }}
                style={{
                  width: 60,
                  height: isMobile ? 28 : 32,
                  borderRadius: 8,
                  position: "absolute",
                  bottom: 20,
                  right: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: isMobile ? 12 : 15,
                    lineHeight: isMobile ? "16.8px" : "21px",
                  }}
                >
                  {isCommentProcessing ? "처리 중" : "등록"}
                </LSBdBody02>
              </MainBtn>
            </div>
          </WhiteBoxContain>

          <div
            style={{
              marginTop: 40,
            }}
          >
            {preCommunityInfo ? (
              <div
                onClick={() => {
                  if (categoryValue > 0) {
                    navigate(
                      `${route.community_detail}/${preCommunityInfo.id}`,
                      {
                        state: { categoryValue: categoryValue },
                      },
                    );
                  } else {
                    navigate(
                      `${route.community_detail}/${preCommunityInfo.id}`,
                    );
                  }
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: isMobile ? "20px 10px" : "20px 10px 20px 30px",
                  borderTop: "1px solid #DBDDE0",
                  borderBottom: "1px solid #DBDDE0",
                  cursor: "pointer",
                }}
              >
                <LSBdH2HeadLine
                  style={{
                    color: "#A4A8B1",
                    marginRight: isMobile ? 15 : 40,
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  이전글
                </LSBdH2HeadLine>
                <ContentTitle
                  style={{
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  {preCommunityInfo.title}
                </ContentTitle>
              </div>
            ) : null}

            {nextCommunityInfo ? (
              <div
                onClick={() => {
                  if (categoryValue > 0) {
                    navigate(
                      `${route.community_detail}/${nextCommunityInfo.id}`,
                      {
                        state: { categoryValue: categoryValue },
                      },
                    );
                  } else {
                    navigate(
                      `${route.community_detail}/${nextCommunityInfo.id}`,
                    );
                  }
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: isMobile ? "20px 10px" : "20px 10px 20px 30px",
                  borderTop: nextCommunityInfo ? "none" : "1px solid #DBDDE0",
                  borderBottom: "1px solid #DBDDE0",
                  cursor: "pointer",
                }}
              >
                <LSBdH2HeadLine
                  style={{
                    color: "#A4A8B1",
                    marginRight: isMobile ? 15 : 40,
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  다음글
                </LSBdH2HeadLine>
                <ContentTitle
                  style={{
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  {nextCommunityInfo?.title}
                </ContentTitle>
              </div>
            ) : null}
          </div>
        </PCContainer>
      </CommunityDetailSection>

      {isDeleteModal ? (
        <ConfirmModal
          isScroll={false}
          title={"게시글을 삭제하시겠습니까?"}
          onClick={() => {
            setIsDeleteModal(false);
          }}
          onYClick={() => {
            setIsDeleteModal(false);
            deleteCommunityFunc();
          }}
        />
      ) : null}

      {isCommentDelModal ? (
        <ConfirmModal
          isScroll={false}
          title={"댓글을 삭제하시겠습니까?"}
          onClick={() => {
            setIsCommentDelModal(false);
          }}
          onYClick={() => {
            setIsCommentDelModal(false);
            deleteCommentFunc();
          }}
        />
      ) : null}

      {isReportModal ? (
        <ReportModal
          isScroll={false}
          onClick={() => {
            setIsReportModal(false);
            setCommentReportId(0);
          }}
          onYClick={(value) => {
            reportFunc(value);
          }}
        />
      ) : null}
    </>
  );
};

export default CommunityDetail;

const CommunityDetailSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #ededff80;
`;

const WhiteBoxContain = styled.div`
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
  padding: ${(props) => (props.$isMobile ? "30px 20px" : "40px")};
  width: 100%;
  border-radius: 15px;
`;

const ContentTitle = styled(LSRgH2HeadLine)`
  color: #000000;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
